define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 133
// module chunks = 1